import { ElSwitch as c } from "element-plus";
import { resolveComponent as i, openBlock as s, createElementBlock as r, normalizeClass as l, createVNode as a, mergeProps as n, toHandlers as m } from "vue";
import { _ as p } from "../_plugin-vue_export-helper-dad06003.js";
import { w as d } from "../util-b2b0dc25.js";
const f = {
  name: "rSwitch",
  props: {
    /**
     * 激活时的背景色，默认为#13C2C2
     */
    activeColor: {
      type: String,
      default: "#13C2C2"
    },
    /**
     * 未激活时的背景色，默认为#CCDAE1
     */
    inactiveColor: {
      type: String,
      default: "#CCDAE1"
    },
    /**
     * 支持设置size大小，可选项包含default、small，默认为default
     */
    size: {
      type: String,
      default: "default"
    }
  },
  components: {
    "el-switch": c
  },
  methods: {}
};
function h(t, u, e, w, _, C) {
  const o = i("el-switch");
  return s(), r(
    "div",
    {
      class: l(["r-switch", e.size === "small" ? "is-small" : ""])
    },
    [
      a(o, n({
        "active-color": e.activeColor,
        "inactive-color": e.inactiveColor
      }, t.$attrs, m(t.$listeners)), null, 16, ["active-color", "inactive-color"])
    ],
    2
    /* CLASS */
  );
}
const v = /* @__PURE__ */ p(f, [["render", h], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/switch/switch.vue"]]), y = d(v);
export {
  y as default
};
